/* BARKÅKRA v10 (2026-10-03 em) – produktkort: samma linje för namn och pris i varje rad av kort, och variantraden som får plats.
   1) Kort grupperas per rad (samma lista + samma topp). Namn och pris får samma minsta höjd som det högsta i raden.
   2) Variantraden: färgprickarna visas om de får plats, annars "N färger", annars döljs färgerna (storlekarna vinner).
   Körs vid start, när fönstret ändrar storlek och när nya kort laddas in (filter, sortering, rekommendationer). */
(function(){
  if (window.__bkCardAlign) return; window.__bkCardAlign = true;
  /* 3/10 em: får storlekarna ändå inte plats (smalt fönster, långa namn) döljs de sista och "+N" räknas om. */
  function fits(vr){ return vr.scrollWidth<=vr.clientWidth+1; }
  function fitChips(vr){
    var n=parseInt(vr.getAttribute('data-n')||'0',10); if(!n) return;
    var chips=[].slice.call(vr.querySelectorAll('a.bk-chip')).filter(function(a){return getComputedStyle(a).display!=='none';});
    var mores=[].slice.call(vr.querySelectorAll('.bk-more')).filter(function(m){return !m.classList.contains('bk-more-x');});
    var x=vr.querySelector('.bk-more-x');
    while(!fits(vr) && chips.length>1){
      chips.pop().style.display='none';
      mores.forEach(function(m){m.style.display='none';});
      if(!x){ x=document.createElement('span'); x.className='bk-chip bk-more bk-more-x'; var last=vr.querySelectorAll('a.bk-chip'); last[last.length-1].after(x); }
      x.textContent='+'+(n-chips.length);
    }
  }
  function fitRow(vr){
    var dots=vr.querySelector('.bk-dots'), fc=vr.querySelector('.bk-fc'), sep=vr.querySelector('.bk-sep');
    [].forEach.call(vr.querySelectorAll('a.bk-chip,.bk-more'),function(e){e.style.display='';});
    var x=vr.querySelector('.bk-more-x'); if(x) x.remove();
    if(dots){ dots.style.display=''; if(fc) fc.hidden=true; if(sep) sep.style.display=''; }
    if(fits(vr)) return;
    if(dots){
      dots.style.display='none'; if(fc) fc.hidden=false;
      if(fits(vr)) return;
      if(fc) fc.hidden=true; if(sep) sep.style.display='none';
    }
    fitChips(vr);
  }
  function align(){
    var cards=[].slice.call(document.querySelectorAll('.product-card-wrapper'));
    var parts=['.card__information > .card__heading','.card-information > .price'];
    cards.forEach(function(c){ parts.forEach(function(s){ var e=c.querySelector('.card > .card__content '+s); if(e) e.style.minHeight=''; }); });
    var groups={};
    cards.forEach(function(c){
      if(!c.offsetParent) return;
      var list=c.closest('ul,.grid,.slider')||document.body;
      if(!list.__bkId) list.__bkId=Math.random().toString(36).slice(2);
      var key=list.__bkId+'_'+Math.round(c.getBoundingClientRect().top+window.scrollY);
      (groups[key]=groups[key]||[]).push(c);
    });
    Object.keys(groups).forEach(function(k){
      var g=groups[k];
      parts.forEach(function(s){
        var els=g.map(function(c){return c.querySelector('.card > .card__content '+s);}).filter(Boolean);
        var h=Math.max.apply(null,els.map(function(e){return e.getBoundingClientRect().height;}).concat([0]));
        if(els.length>1) els.forEach(function(e){ e.style.minHeight=h+'px'; });
      });
    });
    document.querySelectorAll('.bk-vr').forEach(fitRow);
  }
  var t; function soon(){ clearTimeout(t); t=setTimeout(align,60); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',align); else align();
  window.addEventListener('load',align); window.addEventListener('resize',soon);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(align);
  new MutationObserver(function(m){ for(var i=0;i<m.length;i++){ if(m[i].addedNodes.length){ soon(); return; } } }).observe(document.body,{childList:true,subtree:true});
})();